/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 3;
export const HardwareMaterials = new EnumReflection('HardwareMaterials', {
    enum: [
        'black',
        'satinNickel'
    ]
});
export const FloorTextureKey = new EnumReflection('FloorTextureKey', {
    enum: [
        'obsidian',
        'basalt',
        'cabinFever',
        'orbit',
        'domino',
        'gravel',
        'shoreline',
        'coyote',
        'wombat',
        'nightfall',
        'creekbed',
        'tidalwave',
        'concrete'
    ]
});
export const MaterialType = new AjvReflection('MaterialType', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        color: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ]
        },
        materialName: {
            type: 'string',
            enum: [
                'lightWoodMaterial',
                'darkWoodMaterial',
                'whiteWoodMaterial',
                'butcherBlockMaterial',
                'cabinetBodyMaterial',
                'countertopMaterial'
            ]
        },
        swatchUrl: {
            type: [
                'null',
                'string'
            ]
        }
    },
    required: [
        'name',
        'color',
        'materialName',
        'swatchUrl'
    ],
    additionalProperties: false
});
const CabinetShape = new AjvReflection('CabinetShape', {
    type: 'object',
    properties: {
        offsetX: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'offsetX'
    ]
});
const NoCabinetShape = new AjvReflection('NoCabinetShape', {
    type: 'object',
    properties: {
        offsetX: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'offsetX'
    ]
});
const SceneShape = new AjvReflection('SceneShape', {
    type: 'object',
    properties: {
        includeCountertop: {
            type: 'boolean'
        },
        cabinetColor: {
            type: 'string'
        },
        wallCabinetColor: {
            type: 'string'
        },
        countertopColor: {
            type: 'string'
        },
        hardwareMaterial: HardwareMaterials._meta.schema,
        floorTexture: FloorTextureKey._meta.schema,
        hasDifferentWallCabinetColor: {
            type: 'boolean'
        },
        showPrices: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'includeCountertop',
        'cabinetColor',
        'wallCabinetColor',
        'countertopColor',
        'hardwareMaterial',
        'floorTexture',
        'hasDifferentWallCabinetColor',
        'showPrices'
    ]
});
export const Scene = new DomainEntityReflection('Scene', [
    SceneShape._meta.schema
]);
export const BaseCabinet2Door = new DomainEntityReflection('BaseCabinet2Door', [
    CabinetShape._meta.schema
]);
export const BaseCabinet1Drawer2Doors = new DomainEntityReflection('BaseCabinet1Drawer2Doors', [
    CabinetShape._meta.schema
]);
export const BaseCabinet3Drawer = new DomainEntityReflection('BaseCabinet3Drawer', [
    CabinetShape._meta.schema
]);
export const BaseCabinet4Drawer = new DomainEntityReflection('BaseCabinet4Drawer', [
    CabinetShape._meta.schema
]);
export const TallCabinet24 = new DomainEntityReflection('TallCabinet24', [
    CabinetShape._meta.schema
]);
export const TallCabinet36 = new DomainEntityReflection('TallCabinet36', [
    CabinetShape._meta.schema
]);
export const WallCabinet = new DomainEntityReflection('WallCabinet', [
    CabinetShape._meta.schema
]);
export const Countertop = new DomainEntityReflection('Countertop', [
    NoCabinetShape._meta.schema
]);
export const EmptySpace = new DomainEntityReflection('EmptySpace', [
    NoCabinetShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Scene,
    BaseCabinet2Door,
    BaseCabinet1Drawer2Doors,
    BaseCabinet3Drawer,
    BaseCabinet4Drawer,
    TallCabinet24,
    TallCabinet36,
    WallCabinet,
    Countertop,
    EmptySpace
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Scene
]);
export const BaseCabinet = new RawAliasReflection('BaseCabinet', [
    BaseCabinet2Door,
    BaseCabinet1Drawer2Doors,
    BaseCabinet3Drawer,
    BaseCabinet4Drawer
]);
export const TallCabinet = new RawAliasReflection('TallCabinet', [
    TallCabinet24,
    TallCabinet36
]);
export const Cabinet = new RawAliasReflection('Cabinet', [
    ...BaseCabinet.reflections,
    ...TallCabinet.reflections,
    WallCabinet
]);
export const NoCabinet = new RawAliasReflection('NoCabinet', [
    Countertop,
    EmptySpace
]);
export const NonWallCabinetSegment = new RawAliasReflection('NonWallCabinetSegment', [
    ...BaseCabinet.reflections,
    ...TallCabinet.reflections,
    ...NoCabinet.reflections
]);
export const Segment = new RawAliasReflection('Segment', [
    ...Cabinet.reflections,
    ...NoCabinet.reflections
]);
export const SegmentWithPrice = new RawAliasReflection('SegmentWithPrice', [
    Countertop,
    ...Cabinet.reflections
]);
export const Segment24 = new RawAliasReflection('Segment24', [
    ...BaseCabinet.reflections,
    TallCabinet24,
    WallCabinet,
    ...NoCabinet.reflections
]);
export const Segment36 = new RawAliasReflection('Segment36', [
    TallCabinet36
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    BaseCabinet: BaseCabinet.types,
    TallCabinet: TallCabinet.types,
    Cabinet: Cabinet.types,
    NoCabinet: NoCabinet.types,
    NonWallCabinetSegment: NonWallCabinetSegment.types,
    Segment: Segment.types,
    SegmentWithPrice: SegmentWithPrice.types,
    Segment24: Segment24.types,
    Segment36: Segment36.types
};
export const entities = {
    Scene,
    BaseCabinet2Door,
    BaseCabinet1Drawer2Doors,
    BaseCabinet3Drawer,
    BaseCabinet4Drawer,
    TallCabinet24,
    TallCabinet36,
    WallCabinet,
    Countertop,
    EmptySpace
};

//# sourceMappingURL=v3.js.map